import React from "react";
import { styled } from "@mui/material/styles";
import { Fab } from "@mui/material";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Zoom from "@mui/material/Zoom";

const ScrollTop = styled(Fab)(({ theme }) => ({
  position: "fixed",
  bottom: theme.spacing(1),
  right: theme.spacing(1),
}));

export default function ScrollButton({ onClick }) {
  const trigger = useScrollTrigger({
    target: window,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleScroll = (e) => {
    if (onClick) {
      e.preventDefault();
      // If an onClick callback is provided, call it
      onClick();
    } else {
      e.preventDefault();
      // If no onClick callback is provided, scroll to the top
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <Zoom in={trigger}>
      <ScrollTop
        onClick={handleScroll}
        color="primary"
        size="large"
        aria-label="scroll button"
      >
        <KeyboardArrowUpIcon />
      </ScrollTop>
    </Zoom>
  );
}
